import { CargoStateEnum } from "src/app/core/enums/cargoState.enum";
import { TRIP_TYPES } from "src/app/core/enums/tripTypes.enum";
import { Cargo } from "src/app/core/interfaces/cargo";
import { Injectable } from "@angular/core";

@Injectable()
export class ServiceResources {
    public serviceRequestUrls = {
        contractor: "/service-request-form/menu-service/%d/contractor-trip-info",
        origin: "/service-request-form/menu-service/%d/origin-load",
        destination: "/service-request-form/menu-service/%d/destination-download",
        vehicle: "/service-request-form/menu-service/%d/vehicle-service",
        escortedVehicle: "/service-request-form/menu-service/%d/escorted-vehicle",
        cargoType: "/service-request-form/menu-service/%d/load-type",
        loadCharacteristics: "/service-request-form/menu-service/%d/load-characteristics",
        additionalValuesService: "/service-request-form/menu-service/%d/additional-values-service",
        observationsService: "/service-request-form/menu-service/%d/observations-service",
        satelliteLockService: "/service-request-form/menu-service/%d/satellite-lock-service",
        consignmentsService: "/service-request-form/menu-service/%d/consignments-service",
        servicePublication: "/service-request-form/menu-service/%d/service-publication",
    };
    public cargoMock: Cargo = {
        monitoringCompany: {
            id: "9017835729",
            name: "Innovbo sas"
        },
        approval: "Pending approval",
        assignedDriver: false,
        confirmedDriver: false,
        consecutive: 0,
        unlegalizedTravelExpense: false,
        requiresPreoperational: false,
        ministry: true,
        id: "",
        dateLoad: "",
        distancy: 0,
        quantity: 0,
        state: CargoStateEnum.REQUEST,
        numberDocumentSender: "",
        numberDocumentCreatorLoad: "",
        idCompany: "",
        transportCompany: null,
        businessName: "",
        licensePlate: "",
        driver: "",
        secondDriver: "",
        observation: "",
        observationDriver: "",
        riskProfile: {
            id: '',
            name: ''
        },
        labels: [],
        costCenter: {
            id: 0,
            code: '',
            name: '',
            active: false
        },
        cargoModel: {
            tripType: {
                name: TRIP_TYPES.EMPTY,
                regimeType: "",
                letterRetirement: "",
                date: "",
            },
            cargoType: {
                name: "",
                containerMeasure: {
                    size: "",
                },
            },
            serviceType: {
                name: "",
                cost: "",
                id: "transportServices",
            },
            operationType: {
                code: "",
                description: "",
            },
            packagingType: {
                code: "",
                description: "",
            },
            cargoNature: {
                code: "1",
                description: "Carga Normal",
            },
        },
        cargoFeature: {
            productType: {
                name: "",
                type: "No", // Pendiente por implementar
                description: "",
                code: "",
                cargoNature: "",
                cargoNatureId: "",
            },
            vehicleType: {
                name: "",
                vehicleAlias: "",
                trailer: {
                    bodywork: "",
                    axles: 2,
                },
                quantity: 1,
                quality: "",
                bodyWorkType: {
                    name: "",
                },
            },
            cargoMeasure: {
                quantity: 0,
                totalMeasurement: 0,
                unit: "",
                totalWeigth: 0,
                type: "",
                amountDelivered: 0,
            },
            uploadDownload: {
                origin: {
                    name: "",
                    isInternational: false,
                    country: {
                        name: "Colombia",
                        code: "CO",
                    },
                    municipalityCode: "",
                    reteica: 0,
                    addresses: [
                        {
                            id: "",
                            address: "",
                            location: {
                                lat: 0,
                                lng: 0,
                            },
                            time: "",
                            cellphone: "",
                            timePact: 0,
                            minutePact: 0,
                            quantity: 0,
                            thirdPartyConsignment: {
                                address: "",
                                documentType: "",
                                documentNumber: "",
                                branchOffice: "",
                                name: "",
                                documentTypeName: "",
                            },
                            timeType: "",
                        },
                    ],
                },
                destination: [
                    {
                        id: "",
                        name: "",
                        isInternational: false,
                        country: {
                            name: "Colombia",
                            code: "CO",
                        },
                        municipalityCode: "",
                        downloadDate: "",
                        reteica: 0,
                        addresses: [
                            {
                                id: "",
                                guidesId: [],
                                createGuide: false,
                                numberOfGuides: 0,
                                guidesRecipients: [],
                                address: "",
                                location: {
                                    lat: 0,
                                    lng: 0,
                                },
                                time: "",
                                timePact: 0,
                                minutePact: 0,
                                cellphone: "",
                                email: "",
                                quantity: 0,
                                cargoMeasure: {
                                    quantity: 1,
                                    totalMeasurement: 0,
                                    unit: "1",
                                    totalWeigth: 0,
                                    amount: 0,
                                    type: "Apilable",
                                },
                                timeType: '',
                                thirdPartyConsignment: {
                                    address: '',
                                    documentType: '',
                                    documentNumber: '',
                                    branchOffice: '',
                                    name: '',
                                    documentTypeName: ''
                                },
                                consignments: [],
                                containers: [],
                            }
                        ]
                    }
                ]
            }
        },
        shippingCost: {
            freightCost: 0,
            skipFreightRNDCReport: false,
            totalCost: 0,
            advancePercentage: 0,
            valueAdvance: 0,
            advancePaymentMethod: 'Transferencia',
            balancePaymentMethod: 'Transferencia',
            reteicaPercentage: 0,
            reteftePercentage: 0,
            fopatPercentage: 0,
            paymentTime: 30,
            rate: 0,
            initialRate: 0,
            advanceState: false,
            approveBalance: false,
            balanceState: false,
            cashed: false,
            checked: false,
            integralValue: 0,
            integralValuesPercentage: 0,
            paid: false,
            requestedAdvance: { requested: false },
            retefteValue: 0,
            reteicaValue: 0,
            fopatValue: 0,
            totalPaid: 0,
            expirationBillDays: 1
        },
        additionalCosts: [],
        estimatedTime: 0,
        exclusive: false,
        cargoOwner: {
            documentType: '',
            documentNumber: '',
            branchOffice: '',
            name: '',
            //
            address: '',
            location: {
                lat: 0,
                lng: 0
            }
        },
        seal: '',
        container: '',
        containers: [],
        containerExpirationDate: '',
        booking: '',
        realTime: 0,
        axles: 2,
        zone: "private",
        creationDate: '',
        manifestType: {
            code: '',
            description: ''
        },
        manifestDailyTripsCount: 0,
        consecutiveAdditionalCosts: 0,
        minimumApprovedValueSicetac: 0,
        belowSicetac: false,
        fastPayment: false,
        manifestTerms: false,
        freightValueApprovedBelowSicetac: false,
        errorMassiveRequest: false,
        ministryError: false,
        durationToTakeCargo: {
            startDate: '',
        },
        numberOfOffers: 0,
        secondDriverActive: false,
        errorFieldsExcelCargo: {},
        gpsMonitoringIntegration: false,
        uploadedBillingXML: false,
        rate: 0,
        cost: 0,
        consecutiveTraceability: 0,
        holderCompany: '',
        escortedVehicle: {
            licensePlate: '',
            brand: '',
            color: '',
            container: '',
            vehicleType: '',
            driver: {
                documentTypeId: '',
                documentTypeName: '',
                document: '',
                name: '',
                phoneNumber: ''
            },
        },
        prevalidation: {
            valid: false
        },
        requiresPreBill: false
    };
}
